import { useFormContext } from 'react-hook-form';
import { FormField } from '@components/ui/form';
import { FormItemWrapper } from '@components/ui/form/itemWrapper';
import { Input } from '@components/ui/form/input';
import { ExternalScheduleFormValues } from '@forms/schedules/external/types';
import { ExternalScheduleMaterialInputProps } from './types';

export const ExternalScheduleMaterialInput = ({
  option,
  index,
  quantity,
  label,
  className,
  disabled,
}: ExternalScheduleMaterialInputProps) => {
  const { control } = useFormContext<ExternalScheduleFormValues>();

  const inputProps = {
    type: option.valueType === 'number' ? 'number' : 'text',
    inputMode: option.valueType === 'number' ? ('decimal' as const) : undefined,
    rightAlignValue: option.valueType === 'number' && !!option.unit,
    suffixElement: <span>{option.unit}</span>,
  };

  if (index < 0)
    return (
      <FormItemWrapper label={label} className={className}>
        <Input
          {...inputProps}
          title={option[quantity]}
          value={option[quantity] || ''}
          disabled
          readOnly
        />
      </FormItemWrapper>
    );

  return (
    <FormField
      control={control}
      name={`materialOptions.${index}.${quantity}`}
      render={({ field, fieldState: { error } }) => (
        <FormItemWrapper label={label} className={className}>
          <Input {...inputProps} {...field} error={error?.message} disabled={disabled} />
        </FormItemWrapper>
      )}
    />
  );
};
